export const SurroundingIndustriesReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SURROUNDING_INDUSTRIES_LIST_REQUEST":
      return { ...state, loading: true, surroundingIndustries: null };
    case "GET_SURROUNDING_INDUSTRIES_LIST_SUCCESS":
      return { ...state, loading: false, surroundingIndustries: action.payload };
    case "GET_SURROUNDING_INDUSTRIES_LIST_FAILED":
      return { ...state, loading: false, surroundingIndustries: action.payload };
    case "ADD_SURROUNDING_INDUSTRIES_REQUEST":
      return { ...state, loading: true, surroundingIndustries: null };
    case "ADD_SURROUNDING_INDUSTRIES_SUCCESS":
      return { ...state, loading: false, surroundingIndustries: action.payload };
    case "ADD_SURROUNDING_INDUSTRIES_FAILED":
      return { ...state, loading: false, surroundingIndustries: action.payload };
    default:
      return state;
  }
};
